import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { PanelLeft } from 'lucide-react'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import { AssistantInterface } from '@/components/assistant/AssistantInterface'
import { ConversationHistory } from '@/components/assistant/ConversationHistory'
import { useRegisterMobileHeaderAction } from '@/contexts/MobileHeaderActionContext'

export const Route = createFileRoute('/assistant')({
  component: Assistant,
  errorComponent: RouteErrorFallback,
})

function Assistant() {
  const [historyOpen, setHistoryOpen] = useState(false)
  const [conversationId, setConversationId] = useState<string | null>(null)

  const handleSelectConversation = (id: string) => {
    setConversationId(id)
    setHistoryOpen(false)
  }

  const handleNewChat = () => {
    setConversationId(null)
    setHistoryOpen(false)
  }

  const toggleHistory = () => setHistoryOpen((prev) => !prev)

  // Unter `md` traegt die Root-Kopfleiste den Verlaufs-Toggle; die Thread-Leiste
  // blendet sich dort aus, statt eine zweite fast identische Zeile zu stellen.
  useRegisterMobileHeaderAction(PanelLeft, 'Verlauf', toggleHistory)

  return (
    <div className="h-full">
      <ConversationHistory
        open={historyOpen}
        onOpenChange={setHistoryOpen}
        activeConversationId={conversationId}
        onSelectConversation={handleSelectConversation}
        onNewChat={handleNewChat}
      />
      <AssistantInterface
        conversationId={conversationId}
        onConversationCreated={setConversationId}
        onToggleHistory={toggleHistory}
      />
    </div>
  )
}
